<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
  >
    <template
      v-if="canGoBack"
      #header_start
    >
      <ButtonBack @click="navigateBack" />
    </template>
    <template #header_end><HeaderHelp /></template>

    <BaseContentCard
      :title="headerText"
      :description="descriptionText"
      class="kds-color-background-blue-subtle"
    >
      <template #illustration>
        <div
          role="img"
          aria-label="Prescription Check Banner"
          v-html="prescriptionSvg"
        />
      </template>
    </BaseContentCard>

    <template #actions>
      <BaseButton
        :text="ctaButtonText"
        data-qa="submit"
        @click="handleSubmitEvent"
      />
      <BaseButton
        :text="secondaryCtaButtonText"
        data-qa="cancel"
        variant="outlined"
        @click="handleCancelEvent"
      />
    </template>
  </ResponsiveLayout>
  <PrescriptionSupportModal
    ref="supportModalRef"
    show-skip
    @skip="navigateNext('supportSkipped')"
  />
</template>

<script setup>
import { computed, ref } from 'vue'

import { useI18n } from 'petite-vue-i18n'
import env from '@shared/env.js'
import BaseButton from '@shared/components/BaseButton.vue'
import Tracker from '@shared/Tracker'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import BaseContentCard from '@shared/components/BaseContentCard.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'
import HeaderHelp from '@eu/app/components/HeaderHelp.vue'
import * as apiRequest from '@shared/api-endpoints/index.js'
import prescriptionSvg from '@eu/app/assets/img/prescription.svg?raw'
import useOnboardingProgress from '@eu/app/composables/useOnboardingProgress.js'
import useNavigation from '@eu/app/composables/useNavigation'
import ROUTE from '@eu/app/router/appModule/names'
import PrescriptionSupportModal from '@eu/app/components/PrescriptionSupportModal.vue'

const { t } = useI18n()
const { progress } = useOnboardingProgress()
const { navigateNext, navigateBack, canGoBack } = useNavigation(
  ROUTE.PRESCRIPTION_CHECK,
)
const supportModalRef = ref(null)

const appName = computed(() => t('eu__generic__app'))
const headerText = computed(() =>
  !env.features.diga
    ? t('eu__prescription_check__header__diga_disabled')
    : t('eu__prescription_check__header'),
)
const descriptionText = computed(() =>
  !env.features.diga
    ? t('eu__prescription_check__description__diga_disabled')
    : t('eu__prescription_check__description', { app_name: appName.value }),
)
const ctaButtonText = computed(() =>
  !env.features.diga
    ? t('eu__prescription_check__primary_cta__diga_disabled')
    : t('eu__prescription_check__primary_cta'),
)
const secondaryCtaButtonText = computed(() =>
  !env.features.diga
    ? t('eu__prescription_check__secondary_cta__diga_disabled')
    : t('eu__prescription_check__secondary_cta'),
)

const handleSubmitEvent = () => {
  Tracker.trackButtonSelect(
    'continue_prescription',
    'signup_diga_prescription_start',
  )
  apiRequest.sendSubscriptionActivationEntry({
    type: 'user_has_prescription',
  })
  navigateNext('hasPrescription')
}

const handleCancelEvent = () => {
  Tracker.trackButtonSelect('no_prescription', 'signup_diga_prescription_start')
  apiRequest.sendSubscriptionActivationEntry({
    type: 'user_has_no_prescription',
  })
  if (env.features.diga) {
    navigateNext('noPrescription')
  } else {
    supportModalRef.value.open()
  }
}
</script>
